import React from 'react';
import { IconProps } from '../IconProps';
const SvgHearts = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M12.938 7.257c.609-.79 1.06-1.757 1.06-2.894A2.355 2.355 0 0011.655 2a2.372 2.372 0 00-1.943 1.053A2.377 2.377 0 007.77 2a2.356 2.356 0 00-2.29 1.87"
      stroke={primaryColor}
      strokeWidth={1.607}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.993 13.928a.617.617 0 00.576 0c.962-.501 3.998-2.318 3.998-5.273a2.355 2.355 0 00-2.343-2.363 2.372 2.372 0 00-1.943 1.053 2.377 2.377 0 00-1.943-1.053 2.354 2.354 0 00-2.342 2.363c0 2.955 3.037 4.772 3.997 5.273z"
      fill={primaryColor}
      stroke={primaryColor}
      strokeWidth={2.143}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgHearts;
